<template>
    <div class="item-card-bottom">
        <div class="item-sizes" v-if="sizeCount == 5">
            <div class="item-text item-size" v-for="variant in coloredProduct.variants" :key="variant.id">
                <a
                    class="cursor-pointer"
                    @click.stop.prevent="openProduct(coloredProduct, variant.size.code)"
                    :href="getHrefLink(coloredProduct, variant.size.code)"
                    v-if="eligibleSize(variant.size.code)"
                >
                    <span v-if="variant.size.special_code != null">{{ variant.size.special_code }}</span>
                    <span v-else>{{ variant.size.code }}</span></a
                >
            </div>
        </div>

        <!-- Ak ma viac ako 4 ale nie presne 5 -->
        <div class="item-sizes" v-if="sizeCount > 5">
            <div v-for="(variant, index) in coloredProduct.variants" :key="variant.id">
                <div v-if="index < 4" class="item-text item-size">
                    <a
                        class="cursor-pointer"
                        @click.stop.prevent="openProduct(coloredProduct, variant.size.code)"
                        :href="getHrefLink(coloredProduct, variant.size.code)"
                        v-if="eligibleSize(variant.size.code)"
                    >
                        <span v-if="variant.size.special_code != null">{{ variant.size.special_code }}</span>
                        <span v-else>{{ variant.size.code }}</span></a
                    >
                </div>
            </div>

            <div class="item-text item-size item-size-more text-uppercase">
                <a class="cursor-pointer" @click.stop.prevent="openProduct(coloredProduct)" :href="getHrefLink(coloredProduct)">
                    {{ __('frontend_js.product_card.sizes.more') }}</a
                >
            </div>
        </div>

        <!-- Ak ma menej ako 5 velkosti, To Do: ak ma jednu velkost s kodom: None -->
        <div class="item-sizes" v-if="sizeCount < 5">
            <div class="item-text item-size" v-for="variant in coloredProduct.variants" :key="variant.id">
                <a
                    class="cursor-pointer"
                    @click.stop.prevent="openProduct(coloredProduct, variant.size.code)"
                    :href="getHrefLink(coloredProduct, variant.size.code)"
                    v-if="eligibleSize(variant.size.code)"
                >
                    <span v-if="variant.size.special_code != null">{{ variant.size.special_code }}</span>
                    <span v-else>{{ variant.size.code }}</span>
                </a>
            </div>
        </div>

        <div :class="eligibleSizeCount == 0 ? 'item-without-sizes' : ''">
            <div class="item-before-button"></div>
            <div class="item-button-wrapper">
                <span v-if="selectedSize">
                    <a
                        @click.stop.prevent="openProduct(coloredProduct, selectedSize)"
                        :href="getHrefLink(coloredProduct, selectedSize)"
                        class="cursor-pointer shop-button item-button text-uppercase no-underline"
                    >
                        {{ __('frontend_js.colored_product.show.show_detail') }}
                    </a>
                </span>
                <span v-else>
                    <a
                        @click.stop.prevent="openProduct(coloredProduct)"
                        :href="getHrefLink(coloredProduct)"
                        class="cursor-pointer shop-button item-button text-uppercase no-underline"
                    >
                        {{ __('frontend_js.colored_product.show.show_detail') }}
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import collect from 'collect.js';
import openProductMixin from './../../../mixins/open-product-mixin';

export default {
    mixins: [openProductMixin],

    props: {
        coloredProduct: {},
        selectedSize: {},
    },
    computed: {
        sizeCount() {
            return this.coloredProduct.variants.length;
        },
        eligibleSizeCount() {
            return collect(this.coloredProduct.variants).where('size.code', '!==', 'None').count();
        },
    },
    methods: {
        eligibleSize(size) {
            if (size == 'None') {
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss" scoped></style>
